import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from '@/layout/App'
import router from '@/router'
import store from '@/store'
import i18n from '@/lang'
import { vType } from '@/utils'
import Message from '@/components/message'
import VueLuckyCanvas from '@lucky-canvas/vue'
// 引入全局plugin
import '@/plugin'

import { setupSentry } from './plugin/sentry'

setupSentry(Vue)

// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })
Vue.prototype.$message = Message
// Swiper 轮播图
import VueAwesomeSwiper, { swiper, swiperSlide } from './components/VueAwesomeSwiper'
Vue.component('swiper', swiper)
Vue.component('swiperSlide', swiperSlide)
Vue.use(VueAwesomeSwiper)
Vue.use(VueLuckyCanvas)
// 图片懒加载
import VueLazyload from 'vue-lazyload'
import loadingPic from '@/assets/image/logo-grey.svg'
Vue.use(VueLazyload, { preLoad: 1, loading: loadingPic, attempt: 1 })
// 面包屑导航
import myBreadcrumb from '@/components/myBreadcrumb/index'
Vue.component('myBreadcrumb', myBreadcrumb)
// Other
import Viewer from 'v-viewer'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import inputInt from '@/directive/inputInt'
import MetaInfo from 'vue-meta-info'
import globalCommon from '@/utils/globalCommon'
import 'nprogress/nprogress.css'
import 'viewerjs/dist/viewer.css'
// import '@/assets/icon/iconfont.css'
import '@/assets/cccliconfont/icon.scss'
Vue.config.productionTip = false
Vue.config.ignoredElements = [
  // 正则匹配
  /^next-/
]

Vue.use(Viewer).use(GeminiScrollbar).use(globalCommon).use(inputInt).use(MetaInfo)
Vue.prototype.vType = vType
Vue.prototype.$bus = new Vue()
Vue.prototype.cancel = () => {
  const cancelArr = window.axiosCancel
  cancelArr.forEach((ele, index) => {
    ele.cancel('取消了请求')
    delete window.axiosCancel[index]
  })
}

window.openNewTab = function(url, target = '_blank') {
  const aTag = document.createElement('a')
  aTag.href = url
  aTag.target = target
  aTag.click()
}
window.vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
